export default class SmartMatch {
    constructor(data = {}) {
  
      this.scores = {
        experience: data.scores?.experience ?? null,
        skills: data.scores?.skills ?? null,
        overall: data.scores?.overall ?? null,
      };
  
      this.strengths = data.strengths || [];
  
      this.risks = data.risks || [];
    }
  }